import React from "react";
import { faDownload, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import { Table, TableTr, TableTh, TableTd, ButtonIcon } from "ui-kit-sahadevia";

import ModalBankStatement from "./ModalBankStatement";

import { getPrice } from "../../utils/general";

export default class BankStatements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idxModalBankStatement: null,
    };
  }

  render() {
    return (
      <>
        <div
          className="overflow-y"
          style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
        >
          <Table
            title="Relevés bancaire"
            thead={
              <TableTr>
                <TableTh>#</TableTh>
                <TableTh>Nom</TableTh>
                <TableTh>Entrées</TableTh>
                <TableTh>Sorties</TableTh>
                <TableTh>Date d'ajout</TableTh>
                <TableTh>Mois</TableTh>
                <TableTh>Actions</TableTh>
              </TableTr>
            }
            tbody={this.props.bankStatements.map((element, idx) => (
              <TableTr key={idx}>
                <TableTh>
                  <span>{idx + 1}</span>
                </TableTh>
                <TableTd>{element.name}</TableTd>
                <TableTd>{getPrice(element.priceInput)}</TableTd>
                <TableTd>{getPrice(element.priceOutput)}</TableTd>
                <TableTd>{element.dateInsert}</TableTd>
                <TableTd>{element.month}</TableTd>
                <TableTd className="nowrap">
                  <ButtonIcon
                    icon={faTrash}
                    onClick={() => this.props.deleteBankStatement(element.id)}
                  />
                  <ButtonIcon
                    icon={faPen}
                    onClick={() => {
                      this.setState({
                        idxModalBankStatement: idx,
                      });
                    }}
                  />
                  <ButtonIcon
                    icon={faDownload}
                    onClick={() => this.props.downloadBankStatement(element.id)}
                  />
                </TableTd>
              </TableTr>
            ))}
          />
          <ModalBankStatement
            title="Modifier un relevé bancaire"
            show={this.state.idxModalBankStatement !== null}
            data={
              this.state.idxModalBankStatement !== null
                ? this.props.bankStatements[this.state.idxModalBankStatement]
                : {}
            }
            isUpdate={true}
            onClose={(isReload) =>
              this.setState(
                {
                  idxModalBankStatement: null,
                },
                () => {
                  if (isReload) {
                    this.props.getBankStatements();
                  }
                }
              )
            }
          />
        </div>
      </>
    );
  }
}
